import script from "./famousDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./famousDetail.vue?vue&type=script&lang=ts&setup=true"

import "./famousDetail.vue?vue&type=style&index=0&id=810844f4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-810844f4"]])

export default __exports__